export const getStories = ({ storyReducer: { stories = [] } = {} }) => stories;
export const getStoriesFilters = ({ storyReducer: { filter = {} } = {} }) =>
  filter;
export const getCount = ({ storyReducer: { count = 0 } = {} }) => count;
